import { createStyles, makeStyles } from '@material-ui/core'

export const useSeoTextBlockStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1392,
      width: '100%',
      margin: '33px auto 66px',
      [theme.breakpoints.down('xs')]: {
        margin: '25px auto 66px'
      }
    },

    heading: {
      marginBottom: 20,
      fontSize: 20,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      ['@media (max-width: 960px)']: {
        fontSize: 18,
        fontWeight: 400
      }
    },

    headingSmall: {
      marginBottom: 18,
      fontSize: 18,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      ['@media (max-width: 960px)']: {
        fontSize: 16,
        fontWeight: 400
      }
    },

    text: {
      fontSize: 16,
      fontFamily: 'Montserrat',
      fontWeight: 400,
      ['@media (max-width: 960px)']: {
        fontSize: 14,
        fontWeight: 400
      }
    }
  })
)
